export default __webpack_public_path__ + "images/kmu-seal.svg";